import { Injectable } from "@angular/core";
import {Observable, of, Subject} from 'rxjs';
import { DataAccordingToDaySelectedModel, DeleteEJournalDetailsModel, DropDownModel, EditEJournalDetailsModel, FetchListModel, FetchWeekDaysDetailsModel } from "../model/list.model";
import { CommonService } from "src/app/modules/shared/services/common.service";
import { v1URL } from "src/app/modules/shared/constants/urls.constants";

@Injectable({
  providedIn: 'root'
})
export class MyJournalService {
  onWeekDataAdded = new Subject<boolean>();
  constructor(private commonService: CommonService) {
  }

  fetchDailyMealsList(): Observable<FetchListModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Questionnaire List Fetched Successfully',
      data: {
        "total": 0,
        "pageNumber": 0,
        "limit": 0,
        "hasNext": false,
        "hasPrev": false,
        list: [
          {
            mealTime: 'BreakFast',
            myFood: 'Apples',
            amounts: '1',
            lightCounts: 1,
            lightType: 'red'
          }
        ]
      }
    })
  }

  fetchDailyPhysicalActivityList(): Observable<FetchListModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Questionnaire List Fetched Successfully',
      data: {
        "total": 0,
        "pageNumber": 0,
        "limit": 0,
        "hasNext": false,
        "hasPrev": false,
        list: [
          {
            dayTime: 'Morning',
            activity: 'Bicycle racing',
            intensity: 200,
            mins: 15,
            points: 3000
          }
        ]
      }
    })
  }

  fetchDailyScreenActivityList(): Observable<FetchListModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Questionnaire List Fetched Successfully',
      data: {
        "total": 0,
        "pageNumber": 0,
        "limit": 0,
        "hasNext": false,
        "hasPrev": false,
        list: [
          {
            dayTime: 'Morning',
            screenType: 'Computer',
            activity: 'Bicycle racing',
            time: '1 Hour 20 Mins',
          }
        ]
      }
    })
  }

  /* work on this method  */
  fetchSearchedDailyMealList(payload?: { pageNumber: number, searchText: string }): Observable<FetchListModel['response']> {
    const urlConfig = v1URL.journal.searchFood;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));

  }

  fetchSearchedDailyPhysicalActivityList(payload: {
    pageNumber: number,
    searchText: string
  }): Observable<FetchListModel['response']> {
    const urlConfig = v1URL.journal.searchPhysicalActivity;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeekDetails(payload: FetchWeekDaysDetailsModel['request']): Observable<FetchWeekDaysDetailsModel['response']> {
    const urlConfig = v1URL.journal.weekDetails;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url({
      groupId: payload.groupId,
      weekNumber: payload.weekNumber
    }, { forUserId: payload.forUserId }));
  }

  fetchDetailsAccordingToDaySelected(payload: DataAccordingToDaySelectedModel['request']):
    Observable<DataAccordingToDaySelectedModel['response']> {
    const urlConfig = v1URL.journal.eJournalDetails;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchMealType(): Observable<DropDownModel['response']> {
    const urlConfig = v1URL.journal.mealType;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchTodType(): Observable<DropDownModel['response']> {
    const urlConfig = v1URL.journal.todType;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  addEJournalDetails(payload: any): Observable<any> {
    const urlConfig = v1URL.journal.addEJournal;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchColorType(): Observable<DropDownModel['response']> {
    const urlConfig = v1URL.journal.recordType;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  deleteMyJournalRecord(payload: { recordId: any, recordType: any }): Observable<DeleteEJournalDetailsModel> {
    const urlConfig = v1URL.journal.deleteRecords;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  editEJournalRecord(payload: {
    params: { recordType: any, recordId: any },
    data: any
    memberId?: any,
    date?: any
  }): Observable<EditEJournalDetailsModel> {
    const urlConfig = v1URL.journal.editRecord;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.params), payload.data);
  }

  fetchScreenType(): Observable<DropDownModel['response']> {
    const urlConfig = v1URL.journal.screenType;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchActivityType(): Observable<DropDownModel['response']> {
    const urlConfig = v1URL.journal.activityType;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }
}
